import "./index.css";
const About = () => {
return <div className="about-page">

    <section className="about-content">
      <p> Hogcloud, blends technology expertise with artisan craftsmanship. We offer custom, one-of-a-kind gifts, jewelry, magnets, party favors, and decorations—all fully customizable and family-made.
      </p>
      <p>Founded in 2021 by an Arkansas native, Hogcloud began as a technology company specializing in Cloud Consulting and Custom Software Solutions. Brand new for this year, we’ve expanded into unique, handcrafted products, including our popular animal-themed line, designed and created by Violet, as part of our family-run business.
      </p>
      <p>Rooted in innovation and creativity, Hogcloud combines modern tech solutions with artisan, family-made products to bring originality to every project.
      </p>
    </section>
    <hr />
    <section>
      <small>Hogcloud, Inc. is a registered Arkansas S-Corporation located in Fayetteville, Arkansas. 
      We are not affiliated with, endorsed by, or sponsored by the University of Arkansas, the Arkansas Razorbacks, or any of their associated organizations. 
      We are simply proud members of the Fayetteville community who love supporting the Razorbacks as fans.</small>
    </section>

</div>
};

export default About;